import { pushCoachActivity, type PushCoachActivity } from '@/services/push-coach-activity';
import { useMutation } from '@tanstack/react-query';

/**
 * Pushes one coach-authored activity event into the family feed via
 * POST `/api/v1/coaches/me/activities` (authenticated with the coach's Firebase
 * bearer token). Fire-and-forget: `mutate` never throws, so a failed push won't
 * break the action that triggered it.
 *
 * @example
 * const { mutate: logActivity } = usePushCoachActivityMutation();
 * logActivity({
 *   eventId: buildActivityEventId('player', playerId, 'coach_note_added'),
 *   type: 'coach_note_added',
 *   playerId,
 * });
 */
export function usePushCoachActivityMutation() {
  return useMutation({
    mutationFn: (data: PushCoachActivity) => pushCoachActivity(data),
  });
}
